import { makeStyles, Theme } from "../..";
import { statusVariant } from "./StatusIcon";

export const useStyles = makeStyles<Theme, { variant: statusVariant }>(
  (theme) => ({
    status: ({ variant }) => ({
      color: theme.palette.status[variant],
      marginRight: "10px",
    }),
  }),
);
